module.exports = __webpack_public_path__ + "media/images/icon_list/icon_circle_sns_movie-4787c19dd4ce3734c250f613f2c54249.svg";